import { ArrowIcon } from "../../Components/Brand/Icons";
import { CONTACT } from "../../Components/Layout/nav";
import LineField from "../../Components/Form/LineField";
import { useContactForm } from "../../hooks/useContactForm";

/** Light contact sheet at the bottom of the Home page (same treatment as Why us). */
const HomeContact = () => {
  const { fields, setField, errors, status, submit } = useContactForm();

  return (
    <section className="is-home-contact" aria-labelledby="home-contact-title">
      <div className="is-container is-home-contact__panel">
        <div className="is-home-contact__intro">
          <div>
            <h2 id="home-contact-title" className="is-display is-home-contact__title">
              Have something to build? <strong className="is-accent-text">Let’s talk.</strong>
            </h2>
            <p className="is-home-contact__lede">
              Tell us what you’re working on. We’ll come back with questions,
              ideas and a clear plan.
            </p>
          </div>
          <div className="is-home-contact__details">
            <a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            <span>{CONTACT.location}</span>
          </div>
        </div>

        <form className="is-home-contact__form is-line-fields--light" onSubmit={submit} noValidate>
          <div className="is-field-row">
            <LineField
              id="home-contact-name"
              label="Name"
              value={fields.name}
              onChange={setField("name")}
              error={errors.name}
              placeholder="Your name"
              autoComplete="name"
            />
            <LineField
              id="home-contact-email"
              label="Email"
              type="email"
              value={fields.email}
              onChange={setField("email")}
              error={errors.email}
              placeholder="you@company.com"
              autoComplete="email"
            />
          </div>
          <LineField
            id="home-contact-phone"
            label="Phone"
            type="tel"
            value={fields.phone}
            onChange={setField("phone")}
            placeholder="Optional"
            autoComplete="tel"
          />
          <LineField
            id="home-contact-project"
            label="Your project"
            multiline
            value={fields.message}
            onChange={setField("message")}
            error={errors.message}
            placeholder="What are you building?"
          />

          <div className="is-home-contact__submit">
            <button type="submit" className="is-btn is-btn--solid" disabled={status === "sending"}>
              {status === "sending" ? "Sending…" : "Send message"}
              <span className="is-btn__arrow">
                <ArrowIcon />
              </span>
            </button>
            <p className="is-home-contact__status" role="status">
              {status === "success" && "Thanks — your message is on its way. We’ll be in touch soon."}
              {status === "error" && "Something went wrong. Please try again, or email us directly."}
            </p>
          </div>
        </form>
      </div>
    </section>
  );
};

export default HomeContact;
